var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSelectedTimeSlots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.4,
    height: 40.535,
    viewBox: "0 0 66.4 40.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mina_tidsluckor",
    "data-name": "Mina tidsluckor",
    transform: "translate(-11872.658 -2560.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mina_avfallstyper",
    "data-name": "Mina avfallstyper",
    transform: "translate(11873.61 2561.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M306.359,837.015v-3.406c0-9.9,7.412-17.926,16.555-17.926h3.878c9.143,0,16.555,2.786,16.555-8.843v-5.267",
    transform: "translate(-306.359 -799.177)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    transform: "translate(12.103)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_266",
    "data-name": "Ellipse 266",
    cx: 6.394,
    cy: 6.394,
    rx: 6.394,
    ry: 6.394,
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Tidsluckor",
    transform: "translate(11910.031 2571.959)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_588",
    "data-name": "Ellipse 588",
    cx: 14.039,
    cy: 14.039,
    rx: 14.039,
    ry: 14.039,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24159",
    "data-name": "Path 24159",
    d: "M351.921,59.928V71.237l7.5,7.5",
    transform: "translate(-337.882 -56.106)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectedTimeSlots);
export default __webpack_public_path__ + "static/media/Icon_selectedTimeSlots.9909e098578ebc7b5cc662ff78f1ef69.svg";
export { ForwardRef as ReactComponent };